<template>
  <div>
    <el-tabs tab-position="left">
      <el-tab-pane label="Teams">
        <Teams :user="user" />
      </el-tab-pane>
      <el-tab-pane label="Sessions">
        <Session :user="user" />
      </el-tab-pane>
      <el-tab-pane label="Reset">
        <Reset :user="user" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Teams from './View/Teams'
import Session from './View/Session'
import Reset from './View/Reset'

export default {
  components: {
    Teams,
    Session,
    Reset
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isLoading: false
    }
  }
}
</script>
